import { useState, useEffect } from 'react';

const DEFAULT_DEBOUNCE_MS = 500;

export function useDebouncedValue(value, delayMs = DEFAULT_DEBOUNCE_MS) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
